import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { __API_URL__ } from "../../SERVER_URL";

const DrugMin = ({ setMiniDrug, trial, setMessage, setTypeOfMessage }) => {
  const token = localStorage.getItem("token");
  const [drugValue, setDrugValue] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDrugValue((prev) => ({ ...prev, [name]: value }));
  };

  const GetDrugValue = () => {
    axios
      .get(`${__API_URL__}/api/photos/get_drug_value/${trial}/`, {
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => setDrugValue(res.data));
  };

  const updateDrugValue = (e) => {
    e.preventDefault();
    axios
      .patch(
        `${__API_URL__}/api/photos/update_drug_value/${trial}/`,
        { ...drugValue, min_value: drugValue.minimum_value },
        { headers: { Authorization: `Token ${token}` } }
      )
      .then((res) => {
        setDrugValue(res.data);
        setMiniDrug(false);
        toast.success("Drug value updated successfully!");
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Update failed");
      });
  };

  useEffect(() => {
    GetDrugValue();
  }, []);

  return (
    <Dialog open onClose={() => setMiniDrug(false)} maxWidth="sm" fullWidth>
      <DialogTitle>
        Minimum Drug Value
        <IconButton
          aria-label="close"
          onClick={() => setMiniDrug(false)}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={updateDrugValue}>
        <DialogContent dividers>
          <TextField
            fullWidth
            label="Minimum Value"
            size="small"
            type="number"
            name="minimum_value"
            inputProps={{ min: 0 }}
            value={drugValue?.minimum_value || ""}
            onChange={handleChange}
            placeholder="Enter value"
            required
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => setMiniDrug(false)}>
            Cancel
          </Button>
          <Button variant="contained" type="submit">
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default DrugMin;
